module.exports = __webpack_public_path__ + "img/lastNameEle.c8e67a68.svg";